<template>
  <div class="o-layout__container">
    <div class="o-layout__row">
      <div data-test="account-not-found-screen">
        <h1>Sorry, we kunnen je accounts niet samenvoegen</h1>
        <h2 class="h2--secondary">Neem contact met ons op en we helpen je snel weer op weg</h2>
        <p>We kunnen helaas je accounts niet samenvoegen met je eHerkenning-account, omdat we niet met zekerheid kunnen vaststellen dat beide accounts bij elkaar horen.</p>
        <p>Om je goed van dienst te zijn vragen wij je de volgende informatie gereed te houden:</p>
        <ul>
          <li>Voor- en achternaam</li>
          <li>E-mailadres van jouw account</li>
          <li>Bedrijfsnaam</li>
          <li>Vestigingsadres en/of postadres</li>
          <li>Polisnummer(s)</li>
        </ul>
        <p><strong>Error code: EZ103002</strong></p>
      </div>
    </div>
    <div class="o-layout__row">
      <div class="o-layout__col-xl-12 u-border--bt-mediumorange nopadding"/>
      <div class="c-contact o-layout__col-xl-6 u-color-background--ultra-light-grey o-layout__offset-xl-6">
        <h2 v-colored-text="'Kunnen wij je helpen?'" class="u-margin-top--20"/>
        <div class="c-contact__column">
          <ul class="c-contact__contact-list">
            <li class="c-contact__item">
              <a :href="`tel:${contactNum}`"><span class="c-contact__icon c-icon--pict-call"></span>{{contactNum}}</a>
            </li>
            <li class="c-contact__item">
              <a :href="contactForm"><span class="c-contact__icon c-icon--pict-mail"></span>Contactformulier</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  props: {
    contactNum: {
      type: String,
      default: '',
    },
    contactForm: {
      type: String,
      default: '',
    },
  },
};
</script>
